import { render, staticRenderFns } from "./filmPriceV2.vue?vue&type=template&id=21bfb0aa&"
import script from "./filmPriceV2.vue?vue&type=script&lang=js&"
export * from "./filmPriceV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports